import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MedicalRecord } from './types';

export interface RecordState {
  requisitionId: string;
  data: MedicalRecord;
}

@Injectable({ providedIn: 'root' })
export class MedicalRecordStateService {
  private readonly recordState$ = new BehaviorSubject<RecordState | null>(null);

  public saveState(requisitionId: string, data: MedicalRecord): void {
    const dataCopy = JSON.parse(JSON.stringify(data));
    this.recordState$.next({ requisitionId, data: dataCopy });
  }

  public getState(): RecordState | null {
    return this.recordState$.value;
  }

  public clearState(): void {
    this.recordState$.next(null);
  }
}
